import { IBitField } from 'types/src/types';
import { YouTubePreview } from './YouTubePreview';
import { ImagesGallery } from '../../../components/ui/ImagesGallery';

export const ContentRenderer = ({ field }: { field: IBitField }) => {
  switch (field.type) {
    case 'paragraph':
    case 'h1':
    case 'h2':
    case 'quote':
    case 'numbered-list':
    case 'bulleted-list':
      return (
        <div
          dangerouslySetInnerHTML={{ __html: field.content }}
          style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}
        ></div>
      );

    case 'divider':
      return <div className="h-px bg-gray-300 my-4"></div>;

    case 'image':
      return (
        <>
          {field.urls && field.urls.length > 0 && (
            <ImagesGallery url={field.urls[0]} isOne={true} />
          )}
        </>
      );

    case 'multi-images':
      return (
        field.urls &&
        field.urls.length > 0 && (
          <ImagesGallery urls={field.urls} isOne={false} />
        )
      );

    case 'embed-video':
      return <YouTubePreview videoUrl={field.content} />;

    default:
      return (
        <div className="text-red-500">Unsupported field type: {field.type}</div>
      );
  }
};
